import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: "history",
  routes: [
    {
      path: '/dms/login',
      name: 'login',
      component: () => import('@/views/login')
    },
    {
      path: '/dms/third-party-jump',
      name: 'third-party-jump',
      component: () => import('@/views/third-party-jump')
    },
    {
      path: '/dms',
      name: 'dms',
      component: () => import('@/views/home'),
      redirect: { name: "index" },
      children: [
        {
          path: 'index',
          name: 'index',
          component: () => import('@/views/home/index')
        },
        {
          path: 'record',
          name: 'record',
          component: () => import('@/views/home/record')
        },
        {
          path: 'report',
          name: 'report',
          component: () => import('@/views/home/report')
        },
        {
          path: 'report-template',
          name: 'report-template',
          component: () => import('@/views/home/report-template')
        },
        {
          path: 'analyse',
          name: 'analyse',
          component: () => import('@/views/home/analyse')
        },
        {
          path: 'station',
          name: 'station',
          component: () => import('@/views/home/station')
        },
        {
          path: 'point-image',
          name: 'point-image',
          component: () => import('@/views/home/point-image')
        },
        {
          path: 'point-image-edit',
          name: 'point-image-edit',
          component: () => import('@/views/home/point-image-edit')
        },
        {
          path: 'device',
          name: 'device',
          component: () => import('@/views/home/device')
        },
        {
          path: 'alarm',
          name: 'alarm',
          component: () => import('@/views/home/alarm')
        },
        {
          path: 'timing',
          name: 'timing',
          component: () => import('@/views/home/timing')
        },
        {
          path: 'record-group',
          name: 'record-group',
          component: () => import('@/views/home/record-group')
        },
        {
          path: 'version',
          name: 'version',
          component: () => import('@/views/home/version')
        },
        {
          path: 'download-list',
          name: 'download-list',
          component: () => import('@/views/home/download-list')
        },
        {
          path: 'three-direction',
          name: 'three-direction',
          component: () => import('@/views/home/three-direction')
        },
        {
          path: 'system',
          name: 'system',
          component: () => import('@/views/home/system'),
          redirect: { name: "project-manager" },
          children: [{
            path: 'project-manager',
            name: 'project-manager',
            component: () => import('@/views/system/project-manager')
          }, {
            path: 'user-manager',
            name: 'user-manager',
            component: () => import('@/views/system/user-manager')
          }, {
            path: 'device-manager',
            name: 'device-manager',
            component: () => import('@/views/system/device-manager')
          }, {
            path: 'pipe-manager',
            name: 'pipe-manager',
            component: () => import('@/views/system/pipe-manager')
          }, {
            path: 'station-manager',
            name: 'station-manager',
            component: () => import('@/views/system/station-manager')
          }, {
            path: 'station-group-manager',
            name: 'station-group-manager',
            component: () => import('@/views/system/station-group-manager')
          }, {
            path: 'project-edit',
            name: 'project-edit',
            component: () => import('@/views/system/project-edit')
          }]
        },
      ]
    },
    {
      path: '*',
      component: () => import('@/views/login')
    }
  ]
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js